import React, { useState, useEffect } from 'react';
import Widget from '../../../components/Form/Widget/Widget';
import { ButtonSmall } from '../../../components/Button/index';
import iconByMimeType from '../../../components/Files/iconByMimeType';
import InfoToolTip from '../../../components/InfoToolTip';

import * as styles from './styles.css';

function SharedFilesList(props) {
    const [sharedFiles, setSharedFiles] = useState([]);
    const [isExpanded, setIsExpanded] = useState(true);

    useEffect(() => {
        if (props.sharedFiles && props.sharedFiles.toJS) {
            setSharedFiles(props.sharedFiles.toJS())
        }
        setIsExpanded(localStorage.getItem('UID_' + props.currentUserId + '_SharedFiles_isExpanded_' + props.widgetInView) === "false" ? false : true)
    }, [props.sharedFiles]);

    if (!props.widgetInView)
        props.widgetInView = 'general';

    if (!props.currentUserId)
        props.currentUserId = 0


    const handleWidgetExpand = () => {
        setIsExpanded(!isExpanded)
        localStorage.setItem('UID_' + props.currentUserId + '_SharedFiles_isExpanded_' + props.widgetInView, !isExpanded);
    }

    let widgetClass = 'expanded';
    if(!props.publicAccess)
        widgetClass = (props.isCollapsible && isExpanded) ? 'expanded' : 'collapsed';

    return (
        <div className={styles.sharedWidgetWrapper}>
        <Widget
            title="Delade filer"
            className={`${styles.form} ${widgetClass}`}
            widgetVisibilityControls={(props.isCollapsible &&
                <ButtonSmall onClick={handleWidgetExpand} className="widgetCollapseBtn">
                    {isExpanded ? <i className="fa fa-minus-square-o" /> : <i className="fa fa-plus-square-o" />}
                </ButtonSmall>
            )}
            preventControls={true}
            toggleEditable={false}
        >
            {isExpanded && 
                <div className="sharedFilesContent">
                    {sharedFiles && sharedFiles.length > 0 &&
                        <div className="sharedFilesList">
                            <span className={styles.fileListHeader}>Namn</span>
                            {sharedFiles.map((item)=>{
                                    return  <div key={`shared-file-${item.id}`} className={styles.fileItem}>
                                                <i className={"fileIcon " + iconByMimeType(item.mimeType)} />
                                                <a target="_blank" href={(props.publicAccess ? (window.location.origin+"/public/resource-api/files/"+item.id) : ("/api/files/"+item.id))} className={styles.fileName} title={item.description}>
                                                    {item.name}
                                                    <InfoToolTip title="Description">
                                                        {item.description}
                                                    </InfoToolTip>
                                                </a>
                                            </div>
                                    }
                                )
                            }
                        </div>
                    }
                    {!sharedFiles || sharedFiles.length == 0 &&
                        <span>Ingen data tillgänglig.</span>
                    }
                </div>
            }
            
        </Widget>
        </div>
    );
}

export default SharedFilesList;